import React from 'react'
import { RichText } from 'prismic-reactjs'

export default function Text({ data, index }) {
    return (
        <div className="post__text" id={`novedad-detalle-parag-${index}`}>
            <RichText render={data.primary.parag} />
        </div>
    )
}